import { memo, useMemo } from 'react';
import { ICollection } from '../../interfaces';
import { ReactLink } from '@dfl/react-security';
import { COLLECTION_CONTENT_TYPE, COLLECTION_ROUTER } from '../../constants/collection-types';
type CollectionNameCellProps = {
  value: string;
  record: ICollection;
  rowId: string;
};

const CollectionNameCell = ({ record, value, rowId }: CollectionNameCellProps) => {
  const path = useMemo(() => COLLECTION_ROUTER[record?.contentType as COLLECTION_CONTENT_TYPE] ?? '', [record]);

  const isBanner = record?.contentType === COLLECTION_CONTENT_TYPE.BANNER;
  const fullPath = isBanner ? `/cms/collections/${path}/${rowId}/all` : `/cms/collections/${path}/${rowId}`;

  return <ReactLink to={fullPath}>{value}</ReactLink>;
};

export default memo(CollectionNameCell);
